module.exports = "/_next/static/images/notfound-dfc9a6eddfc4dafa1e97fe57eb23f43c.png";